'use client'

import { createClientFlags } from '@hello-aria/flags/client'

import { featureFlagDefinitions } from '@/shared/models/featureFlagModels'

const FLAGS_ROUTE = '/api/flags'

export const { FlagsLoader, FlagsProvider, useFlags } = createClientFlags(featureFlagDefinitions, FLAGS_ROUTE)
